import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Inventorys*/
export const registerInventory = async (inventoryData) => {
  try {
    const response = await api.post("/inventorys", inventoryData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "inventory");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchInventorysFromAPI = async (page = 1, perPage = 10, search = "") => {
  try {
    const response = await api.get("/inventories/history", {
      params: { page, per_page: perPage, ...search },
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "inventory");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteInventorysFromAPI = async (inventoryId) => {
  try {
    const response = await api.delete(`/inventorys/${inventoryId}`, {
      params: { inventory_id: inventoryId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "inventory");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchInventorysById = async (inventoryId) => {
  try {    
    const response = await api.get(`/inventorys/${inventoryId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data inventory", "inventory");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateInventory = async (id, inventoryData) => {
  try {
    const response = await api.put(`/inventorys/${id}`, inventoryData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "inventory");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/** One Inventory History event with its parts (GET /inventories/:id). */
export const fetchInventoryHistoryDetail = async (inventoryId) => {
  try {
    const response = await api.get(`/inventories/${encodeURIComponent(inventoryId)}`);
    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get detail", "inventory history");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadInventoryExcel = async (searchParams = {}) => {
  try {
    const response = await api.get("/inventories/history/export", {
      params: searchParams,
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("download", "inventory history");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

// Update Stock APIs
export const uploadUpdateStockExcel = async (formData) => {
  try {
    const response = await api.post("/inventories/update-stock/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload update stock file", "update stock");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchUpdateStockData = async (vendorCode) => {
  try {
    const response = await api.get(`/inventories/update-stock/${vendorCode}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get update stock data", "update stock");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadUpdateStockTemplate = async (vendorName, vendorCode) => {
  try {
    const response = await api.get("/inventories/update-stock/template/download", {
      params: { 
        vendor_name: vendorName,
        vendor_code: vendorCode || '',
      },
      responseType: 'blob',
    });
    
    // Create blob URL and trigger download
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Template_Update_Stock_${vendorName?.trim().replace(/\s+/g, '_') || 'Supplier'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    const fallback = generateErrorMessage("download update stock template", "update stock");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchUpdateStockHistory = async (vendorCode, page = 1, perPage = 10, search = '') => {
  try {
    const response = await api.get("/inventories/update-stock/history", {
      params: {
        vendor_code: vendorCode || '',
        page,
        per_page: perPage,
        search,
      },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get update stock history", "update stock");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const adjustStockQuantity = async (adjustData) => {
  try {
    const response = await api.put("/inventories/update-stock/adjust", adjustData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("adjust stock quantity", "update stock");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


